/**
 * @generated SignedSource<<6004300b9bea551f0ac8a074b6dbad7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeetingRecordingVisibility = "PRIVATE" | "PUBLIC" | "WORKSPACE";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
export type SendNotesRecordingModalQuery$variables = {
  id: string;
};
export type SendNotesRecordingModalQuery$data = {
  readonly node: {
    readonly __typename: "Note";
    readonly event: {
      readonly attendees: ReadonlyArray<{
        readonly __typename: "Attendee";
        readonly email: string;
        readonly fullName: string | null;
        readonly image: string | null;
        readonly invitable: boolean;
        readonly isOptional: boolean | null;
        readonly isOrganizer: boolean | null;
        readonly responseStatus: ResponseStatusChoices | null;
        readonly title: string | null;
        readonly user: {
          readonly id: string;
          readonly isActive: boolean;
          readonly isGuest: boolean;
        } | null;
      } | null>;
    } | null;
    readonly externalUsers: ReadonlyArray<{
      readonly __typename: "User";
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly invitable: boolean;
      } | null;
      readonly isActive: boolean;
      readonly isExternal: boolean;
      readonly isGuest: boolean;
      readonly type: UserType;
    }> | null;
    readonly id: string;
    readonly meetingRecordingLink: {
      readonly id: string;
      readonly url: string;
      readonly visibility: MeetingRecordingVisibility;
    };
    readonly meetingRecordings: ReadonlyArray<{
      readonly hasSummary: boolean;
      readonly id: string;
    }> | null;
    readonly noteuserSet: ReadonlyArray<{
      readonly id: string;
      readonly lastSeenAt: string | null;
      readonly user: {
        readonly __typename: "User";
        readonly email: string;
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly internalAttributes: {
          readonly invitable: boolean;
        } | null;
        readonly isActive: boolean;
        readonly isExternal: boolean;
        readonly isGuest: boolean;
        readonly type: UserType;
      };
    }>;
    readonly stream: {
      readonly isExternal: boolean;
    };
    readonly version: number;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly viewer: {
    readonly account: {
      readonly allowPublicRecap: boolean;
      readonly emailDomainList: ReadonlyArray<string>;
      readonly isPersonalType: boolean;
      readonly name: string;
    };
    readonly user: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
    };
  };
};
export type SendNotesRecordingModalQuery = {
  response: SendNotesRecordingModalQuery$data;
  variables: SendNotesRecordingModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowPublicRecap",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPersonalType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecordingLink",
  "kind": "LinkedField",
  "name": "meetingRecordingLink",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "forCopy",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "url",
      "storageKey": "url(forCopy:true)"
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecording",
  "kind": "LinkedField",
  "name": "meetingRecordings",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSummary",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Attendee",
  "kind": "LinkedField",
  "name": "attendees",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOptional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrganizer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v23 = [
  (v10/*: any*/),
  (v5/*: any*/),
  (v21/*: any*/),
  (v6/*: any*/),
  (v22/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/),
  (v18/*: any*/),
  (v17/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v24 = [
  (v10/*: any*/),
  (v5/*: any*/),
  (v21/*: any*/),
  (v6/*: any*/),
  (v22/*: any*/),
  (v7/*: any*/),
  (v15/*: any*/),
  (v18/*: any*/),
  (v17/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v5/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesRecordingModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "externalUsers",
                "plural": true,
                "selections": (v23/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesRecordingModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "externalUsers",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "668e9402e2f7c9293f95f3a780d68ffe",
    "id": null,
    "metadata": {},
    "name": "SendNotesRecordingModalQuery",
    "operationKind": "query",
    "text": "query SendNotesRecordingModalQuery(\n  $id: ID!\n) {\n  viewer {\n    account {\n      name\n      allowPublicRecap\n      emailDomainList\n      isPersonalType\n      id\n    }\n    user {\n      id\n      email\n      fullName\n    }\n    id\n  }\n  node(id: $id) {\n    __typename\n    ... on Note {\n      id\n      version\n      meetingRecordingLink {\n        id\n        visibility\n        url(forCopy: true)\n      }\n      meetingRecordings {\n        id\n        hasSummary\n      }\n      stream {\n        isExternal\n        id\n      }\n      event {\n        attendees {\n          __typename\n          email\n          fullName\n          image\n          invitable\n          title\n          responseStatus\n          isOptional\n          isOrganizer\n          user {\n            id\n            isGuest\n            isActive\n          }\n        }\n        id\n      }\n      noteuserSet {\n        id\n        lastSeenAt\n        user {\n          __typename\n          id\n          type\n          email\n          firstName\n          fullName\n          image\n          isActive\n          isGuest\n          isExternal\n          internalAttributes {\n            invitable\n            id\n          }\n        }\n      }\n      externalUsers {\n        __typename\n        id\n        type\n        email\n        firstName\n        fullName\n        image\n        isActive\n        isGuest\n        isExternal\n        internalAttributes {\n          invitable\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "af75fc964c45b97576ba31631ee8a79f";

export default node;
